import React from 'react'

import SEO from '@/components/Seo'
import Ranking from '@/components/Ranking'
import Admision from '@/components/Ranking/Admision'
import Sidebar from '@/components/Ranking/Sidebar'

const IndexPage = ({ pageContext }) => {
  const {
    admision,
    data,
    ranking,
    allRankings,
    activeRanking,
    allData,
  } = pageContext

  return (
    <>
      <SEO />
      <div className="grid md:grid-cols-8 gap-4 mx-auto xl:container ">
        <div className="xl:col-span-6 lg:col-span-5 md:col-span-4 pt-4 pb-4 sm:pt-20">
          <Ranking
            activeRankingIndex={activeRanking}
            allRankings={allRankings}
            ranking={ranking}
            career={data}
            allData={allData}
            sectionslug="rankings-por-carrera"
          />
        </div>
        <div className="xl:col-span-2 lg:col-span-3 md:col-span-4 sm:pt-20 pt-4 pb-4">
          <Sidebar
            activeRankingIndex={activeRanking}
            allRankings={allRankings}
            ranking={ranking}
            career={data}
            allData={allData}
            sectionslug="rankings-por-carrera"
          />
        </div>
      </div>
      <Admision career={data} table={admision} />
    </>
  )
}

export default IndexPage
